var map = {
	"./GRANDE_headerbanner.png": "./src/assets/banners/GRANDE_headerbanner.png",
	"./MINI_headerbanner.png": "./src/assets/banners/MINI_headerbanner.png",
	"./headerbanner-grande.jpg": "./src/assets/banners/headerbanner-grande.jpg",
	"./headerbanner-mini.jpg": "./src/assets/banners/headerbanner-mini.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/banners sync recursive ^\\.\\/.*$";